/**
 * How a `central_medical_lexicon_audit` row reads in the Audit tab.
 *
 * The table stores the SQL verb the trigger fired on (INSERT/UPDATE/DELETE)
 * plus the batch marker `apply()` writes (IMPORT). Those are database
 * words in an otherwise Dutch table, so they are translated here rather
 * than rendered raw.
 */

/** The actor the trigger records for a change made outside the app. */
export const EXTERNAL_ACTOR = "service_role";

/**
 * What `service_role` means, in the curator's own words. A row carrying it
 * was not written through /admin — the import script or psql on the
 * primary changed it — which is worth saying out loud instead of leaving
 * in a source comment.
 */
export const EXTERNAL_ACTOR_NOTE =
  "service_role betekent: gewijzigd buiten /admin om, bijvoorbeeld door het " +
  "importscript of rechtstreeks op de database.";

const ACTION_LABELS: Record<string, string> = {
  INSERT: "Toegevoegd",
  UPDATE: "Gewijzigd",
  DELETE: "Verwijderd",
  IMPORT: "Import",
};

/** The Dutch label for an audit op; an unknown verb is shown unchanged. */
export function auditActionLabel(op: string): string {
  return ACTION_LABELS[op] ?? op;
}

export function isExternalActor(actor: string | null): boolean {
  return actor === EXTERNAL_ACTOR;
}

/** True when the note under the table is worth showing at all. */
export function hasExternalActor(entries: readonly { actor: string | null }[]): boolean {
  return entries.some((entry) => isExternalActor(entry.actor));
}
